import * as React from "react";
import type { SVGProps } from "react";
const SvgIcInventory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.615 3.02 17.041 3c2.945-.007 4.782 2.068 4.79 5.01l.018 7.937c.007 2.944-1.82 5.026-4.766 5.033L8.658 21c-2.945.007-4.782-2.068-4.789-5.01l-.018-7.938C3.844 5.109 5.68 3.027 8.615 3.02"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.28 10.19v3.611c0 .466-.25.897-.653 1.131L13.5 16.737a1.3 1.3 0 0 1-1.306 0l-3.126-1.805a1.31 1.31 0 0 1-.653-1.13V10.19c0-.466.25-.897.653-1.13l3.126-1.806a1.3 1.3 0 0 1 1.306 0l3.126 1.806c.404.233.653.664.653 1.13"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.6 9.524 4.246 2.457 4.246-2.457M12.848 16.919v-4.942"
    />
  </svg>
);
export default SvgIcInventory;
